import { render, staticRenderFns } from "./CourseWare.vue?vue&type=template&id=db193c26&scoped=true"
import script from "./CourseWare.vue?vue&type=script&lang=js"
export * from "./CourseWare.vue?vue&type=script&lang=js"
import style0 from "./CourseWare.vue?vue&type=style&index=0&id=db193c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db193c26",
  null
  
)

export default component.exports